module.exports = __webpack_public_path__ + "img/1557614091345928193.d83ca556.png";